import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Menu from './components/Menu';
import Landing from './components/Landing';
import Services from './components/Services';
import Developments from './components/Developments';
import HowItWorks from './components/HowItWorks';
import SoftwareWebDevelopment from './components/services/SoftwareWebDevelopment';
import Cybersecurity from './components/services/Cybersecurity';
import ManagedItSmb from './components/services/ManagedItSmb';
import CloudServices from './components/services/CloudServices';
import './styles.css';

const App = () => {
  return (
    <>
      <Menu />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/software-web-development" element={<SoftwareWebDevelopment />} />
        <Route path="/services/cybersecurity" element={<Cybersecurity />} />
        <Route path="/services/managed-it-smb" element={<ManagedItSmb />} />
        <Route path="/services/cloud-services" element={<CloudServices />} />
        <Route path="/developments" element={<Developments />} />
      </Routes>
    </>
  );
};

const WrappedApp = () => (
  <Router>
    <App />
  </Router>
);

export default WrappedApp;
